"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const timezones_json_1 = __importDefault(require("./timezones.json"));
exports.default = timezones_json_1.default;
